﻿const $ = require('jquery');

export default function () {
	
	$(document).ready(function () {

		var activeIndex = 1;
		var disableAuto = false;
		var maxIndex = $(".herobanner__carousel__item").length + 1;

		function Slide(button) {
			$(".herobanner__carouselnav button").removeClass("active");
			button.addClass("active");
			var index = $(button).attr("data-carouselindex");


			$(".herobanner__carousel__item").removeClass("active");
			$(`.herobanner__carousel__item[data-carouselindex='${index}']`).addClass("active");

			$(".herobanner__imagewrapper__inner__picturewrapper").removeClass("active");
			$(`.herobanner__imagewrapper__inner__picturewrapper[data-carouselindex='${index}']`).addClass("active");
		}

		$(".herobanner__carouselnav button").click(function () {
			disableAuto = true;
			var targetButton = $(this);
			Slide(targetButton);
		});

		function AutoScrollCarousel() {

			if (!disableAuto) {

				if (activeIndex == maxIndex) {
					activeIndex = 1;
				}
				
				var targetButton = $(`.herobanner__carouselnav button[data-carouselindex='${activeIndex}']`);
				Slide(targetButton);

				activeIndex = activeIndex + 1;

				setTimeout(AutoScrollCarousel, 6000);
			}

		}

		AutoScrollCarousel();
	});

}